import React from 'react';
import { ArrowRight, Zap } from 'lucide-react';

const VendorModel = () => {
  return (
    <div className="max-w-3xl mx-auto">
      <div className="bg-white rounded-2xl shadow-lg border border-gray-200 overflow-hidden">
        {/* Main Plan Section */}
        <div className="p-8 md:p-10">
          <div className="flex items-center gap-3 mb-4">
            <div className="bg-brand-blue/10 p-2 rounded-lg">
              <Zap className="w-6 h-6 text-brand-blue" />
            </div>
            <h3 className="text-2xl font-bold text-brand-darkgrey">
              Cutshort Assisted
            </h3>
          </div>
          
          <div className="mb-8">
            <h4 className="text-2xl md:text-3xl font-bold text-brand-darkgrey mb-3">
              Start making offers in 5 days.
            </h4>
            <p className="text-lg text-brand-grey">
              Our recruiting experts use the Cutshort engine to handle sourcing, interview scheduling, offer negotiation, and engagement.
            </p>
          </div>
          
          <div className="flex flex-col md:flex-row md:items-center justify-between gap-6">
            <div>
              <p className="text-3xl font-bold text-brand-blue mb-1">8.33% of CTC</p>
              <p className="text-brand-grey font-medium">Pay only on successful hires</p>
            </div>
            <a 
              href="https://cutshort.io/a/generic-emp-form" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 bg-brand-blue text-white px-8 py-3.5 rounded-full font-medium hover:bg-brand-blue/90 transition-colors"
            >
              Get onboarded now
              <ArrowRight className="w-4 h-4" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VendorModel;
